export default __webpack_public_path__ + "static/media/totalBatches.d61b2072.svg";